import React, { useCallback, useState, useEffect } from "react"
// import PropTypes from "prop-types"
import TextField from "@bappweb/textfield"
import Button from "@bappweb/button"
import Block from "@bappweb/block"
import Image from "@bappweb/image"
import Icon from "@bappweb/icon"
// import { PostCall } from "@bappweb/utils"
import "./assets/styles/style.scss"
import errorSvg from "./assets/svg/captcha-error.svg"

const Captcha = (props) => {
  const [captchaValues, setCaptchaValues] = useState({
    typedText: props.value,
    captcha: props.captcha || null,
    refreshCount: 0
  })
  
  useEffect(() => {
    if (props.captcha !== captchaValues.captcha) {
      let refreshCount = 0
      if (captchaValues.captcha) {
        refreshCount = captchaValues.refreshCount + 1
      }
      setCaptchaValues({ ...captchaValues, captcha: props.captcha, refreshCount: refreshCount })
    }

    if (props.value !== captchaValues.typedText) {
      setCaptchaValues({ ...captchaValues, typedText: props.value })
    }
  }, [props, captchaValues])

  const handleRefreshClick = useCallback(() => {   
    if (props.captcha !== captchaValues.captcha) {
      setCaptchaValues({
        ...captchaValues,
        captcha: props.captcha
      })
    }

    if (props.refreshClick) {
      props.refreshClick()
    }
  }, [props, captchaValues])

  const handleChange = useCallback(
    (e) => {
      setCaptchaValues({ ...captchaValues, typedText: e.target.value })

      props.onChange?.(e)
    },
    [captchaValues, props]
  )

  
  return ( 
      <Block
        className="bapp-captcha-container">
        <TextField
          label={props.label}
          placeholder={props.placeholder}
          type="text"
          name={props.name}
          value={captchaValues.typedText}
          readOnly={!captchaValues.captcha}
          validations={props.captchaValidate ? props.validations : ""}
          maxLength={props.maxLength}
          onChange={handleChange}
        />
        <Block className="bapp-captcha-wrapper">
          <Block className="bapp-captcha">
            {captchaValues.captcha && (
              <Image
                className=""
                path={"data:image/png;base64," + captchaValues.captcha}
                fallbackText="Captcha"
              />
            )}
            {!captchaValues.captcha && (
              <Image className="" path={errorSvg} fallbackText="Captcha error" />
            )}
          </Block>
          <Block className="bapp-captcha-refresh">
            <Button
              custom
              disabled={captchaValues.refreshCount >= props.maxRefreshCount}
              className={"bapp-icon-update"}
              iconName={Icon.Icons.ActionsControlsRotateRight}
              onClick={handleRefreshClick}
              aria-label="Refresh captcha"
            />
          </Block>
        </Block>
      </Block>
  )
}

// Captcha.propTypes = {
//   label: PropTypes.string,
//   id: PropTypes.string,
//   name: PropTypes.string.isRequired,
//   value: PropTypes.string,
//   className: PropTypes.string,
//   placeholder: PropTypes.string,
//   captcha: PropTypes.string,
//   params: PropTypes.object,
//   url: PropTypes.string,
//   refreshClick: PropTypes.func,
//   maxRefreshCount: PropTypes.number,
//   validations: PropTypes.array,
//   maxLength: PropTypes.number,
//   bordered: PropTypes.bool
// }

Captcha.defaultProps = {
  maxRefreshCount: 3
}

export default Captcha
